<template>
  <v-col cols="12">
    <v-col class="col-sm-12 col-xs-12">
      <v-card color="white" dark class="rounded-xl" flat>
        <v-card-title class="text-h5" style="color: #6b6868"> </v-card-title>

        <v-card-subtitle>
          <v-alert
            outlined
            type="error"
            prominent
            border="left"
            style="margin-top: 1em"
            v-if="formErrors.length > 0"
          >
            <b>Veuillez corriger les erreurs suivantes:</b>
            <ul>
              <li v-for="(error, index) in formErrors" :key="index">
                • {{ error }}
              </li>
            </ul>
          </v-alert>
          <section
            style="
              background: rgba(255, 255, 255, 0.9);
              color: #777171;
              padding: 1em;
            "
          >
            <v-form>
              <v-row>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-autocomplete
                    label="Langues"
                    v-model="langue"
                    prepend-inner-icon="mdi-format-list-bulleted-type"
                    light
                    item-text="name"
                    item-value="id"
                    required
                    return-object
                    chips
                    :items="languesListItems"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="12" xs="12">
                  <v-btn class="col-12" color="success" @click="addLangue">
                    <v-icon left>mdi-table-plus</v-icon>
                    Ajouter
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="this.langues.length > 0">
                <v-col cols="12">
                  <v-card flat light>
                    <v-card-title>Mes langues</v-card-title>
                    <v-card-text>
                      <template>
                        <v-timeline>
                          <v-timeline-item
                            v-for="(langue, index) in this.langues"
                            :key="index"
                          >
                            <template>
                              <v-card flat light>
                                <v-card-title>{{ langue.name }}</v-card-title>
                                <v-card-actions>
                                  <v-btn-toggle
                                    dense
                                    background-color="primary"
                                    dark
                                  >
                                    <v-btn
                                      icon
                                      @click="deleteUserLangue(langue, index)"
                                    >
                                      <v-icon>mdi-delete-sweep</v-icon>
                                    </v-btn>
                                  </v-btn-toggle>
                                </v-card-actions>
                              </v-card>
                            </template>
                          </v-timeline-item>
                        </v-timeline>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="12" xs="12">
                  <v-btn
                    class="col-12"
                    color="primary"
                    @click="updateUserLangues"
                  >
                    Enregistrer
                  </v-btn>
                </v-col>
              </v-row>
              <hr />
              <v-row style="text-align: center; padding: 2em">
                <v-col cols="12">
                  <v-btn
                    class="col-12"
                    color="indigo"
                    rounded
                    outlined
                    x-large
                    block
                    @click="downloadResume"
                  >
                    <v-icon left dark large> mdi-cloud-download </v-icon>
                    Télécharger mon CV
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </section>
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "CvLanguageForm",
  props: {
    informationsNextStepCallBack: Function,
    templateId: Object,
  },

  data: function () {
    return {
      currentSeeker: null,
      calendarMinDate: null,
      calendarMinDate1: null,
      calendarMaxDate: null,
      langue: null,
      formFields: {
        level: null,
      },
      langues: [],
      date: null,
      currentUserInfos: {},
      menu: false,
      downloadLink: "",
      menu1: false,
      formErrors: [],
      languesListItems: [],
      lastIndex: -1,
    };
  },

  methods: {
    displayDateToFrFormat(date) {
      const splittedDate = date.split("-");
      console.log(splittedDate);
      console.log(`${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`);
      return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
    },

    checkFormationIsValid() {
      this.formErrors = [];
      let isValid = true;

      if (this.interest === null) {
        isValid = false;
        this.formErrors.push("Un Choix est obligatoire.");
      }

      return isValid;
    },
    addLangue() {
      if (this.checkFormationIsValid()) {
        // add formation to local store
        let langueTmp = {};
        let tmp = this.lastIndex + 1;
        langueTmp["_index"] = tmp;
        langueTmp.langue = this.langue.id;
        langueTmp.name = this.langue.name;
        this.langues.push(langueTmp);

        this.lastIndex = tmp;
        this.langue = null;
      }
    },

    save(date) {
      this.$refs.menu.save(date);

      const formattedDate = date.split("-");
      this.calendarMinDate1 = `${parseInt(formattedDate[0], 10)}-${(
        "0" + parseInt(formattedDate[1], 10)
      ).slice(-2)}-${("0" + parseInt(formattedDate[2], 10)).slice(-2)}`;
    },
    save1(date) {
      this.$refs.menu1.save(date);
    },

    updateUserLangues: async function () {
      if (this.langues.length > 0) {
        const httpClient = new HttpClient();
        this.langues.forEach(async (el) => {
          if (!("id" in el)) {
            await httpClient
              .createSeekerLangues(
                {
                  langue: el.id,
                  seeker: `/api/seekers/${this.currentSeeker.id}`,
                  name: el.name,
                },
                localStorage.getItem("jwt-token")
              )
              .then(async (value) => {
                let tmpSeeker = {
                  id: this.currentSeeker.id,
                  isPersonalInformationsFilled: true,
                  isProfessionalExperiencesFilled: true,
                  isSchoolInformationsFilled: true,
                  isSkillsInformationsFilled: true,
                };

                await httpClient
                  .updateSeekerInformations(
                    tmpSeeker,
                    localStorage.getItem("jwt-token")
                  )
                  .then((res) => {
                    this.currentSeeker = res.data;
                    this.informationsNextStepCallBack(7);
                  })
                  .catch((reason) => {
                    if (reason.response.status === 401) {
                      this.$router.push("/logout");
                    }

                    alert("Une erreur s'est produite");
                    console.error(reason);
                  });
                this.load();
              })
              .catch((reason) => {
                if (reason.response.status === 401) {
                  this.$router.push("/logout");
                }
                this.formErrors = [];
                this.formErrors.push("Une erreur s'est produite");
              });
          }
          this.informationsNextStepCallBack(7);
        });
        this.informationsNextStepCallBack(7);
      }
    },

    load: async function () {
      const httpClient = new HttpClient();

      httpClient
        .getSeekerLanguesByUser(localStorage.getItem("jwt-token"))
        .then((value) => {
          this.seekerLanguesList = value.data;

          this.langues = this.seekerLanguesList.map((el) => ({
            id: el.id,
            name: el.name,
          }));
        })
        .catch((reason) => {
          if (reason.response.status === 401) {
            this.$router.push("/logout");
          }
          this.formErrors.push(reason);
          console.error(reason);
        });
    },

    deleteUserLangue: async function (el, index) {
      const httpClient = new HttpClient();
      if ("id" in el) {
        await httpClient
          .deleteSeekerLangues(
            {
              id: el.id,
            },
            localStorage.getItem("jwt-token")
          )
          .then(async (value) => {
            this.langues.splice(index, 1);
            console.log("value", value);
          })
          .catch((reason) => {
            if (reason.response.status === 401) {
              this.$router.push("/logout");
            }
            this.formErrors = [];
            this.formErrors.push("Une erreur s'est produite");
          });
      } else {
        this.langues.splice(index, 1);
      }
    },

    downloadResume: async function () {
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      this.downloadLink = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/download/resume/${this.templateId.id}/${currentUser.id}?access_token=${localStorage.getItem("jwt-token")}`;
      window.open(this.downloadLink);
    },
  },
  created() {
    const httpClient = new HttpClient();

    httpClient
      .getCurrentUserInformations(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.currentUserInfos = value.data;

        httpClient
          .getCurrentSeeker(localStorage.getItem("jwt-token"))
          .then((res) => {
            this.currentSeeker = res.data;
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.$router.push("/logout");
            }
          });
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 401) {
          this.$router.push("/logout");
        }
      });

    httpClient
      .getLangues(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.languestList = value.data["hydra:member"];
        this.languestList.forEach((elt) => {
          this.languesListItems.push({
            id: elt["@id"],
            name: elt["name"],
          });
        });
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        }
        this.formErrors.push(reason);
        console.error(reason);
      });

    this.load();
  },
});
</script>

<style scoped></style>
